import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { roleList } from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Button,
    Table,
    message,
    Input,
    Select,
    Menu,
    Icon,
    Form,
    Modal,
    InputNumber,
    Dropdown,
    Tag,
} from "antd";

export default class PlayerList extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            user_id: undefined,
            name: undefined,
            club_id: undefined,
            level: undefined,
        },
        formData: {}, // 表单数据
        data: [], // 表格数据
        dataInfo: {}, // 数据信息
        unionClubList: [], // 联盟俱乐部列表
        superUnionClubList: [], // 超盟俱乐部列表
        roleList: roleList, // 角色列表,
    };

    componentDidMount () {
        this.fetchData();
        if (Cookie.get("unionType") === "super_union") {
            this.fetchSuperUnionClubList();
        } else {
            this.fetchUnionClubList();
        }
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/union_club_user_list", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                    dataInfo: res || {},
                });
            });
    };

    /**
     * 获取联盟俱乐部列表
     */
    fetchUnionClubList = () => {
        this.setState({ loading: true });
        axios.get("/v1/api/union_club_list").then((res) => {
            this.setState({
                unionClubList: res.data || [],
            });
        });
    };

    /**
     * 获取超盟俱乐部列表
     */
    fetchSuperUnionClubList = () => {
        this.setState({ loading: true });
        axios.get("/v1/api/super_union_club_list").then((res) => {
            this.setState({
                superUnionClubList: res.data || [],
            });
        });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/union_club_user_list_export", {
                params: {
                    ...this.state.queryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 提交表单
     */
    handleSubmit = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.type === "sendJetton" ||
                    this.state.type === "recycleJetton"
                ) {
                    // 发放、回收筹码
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendJetton"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.formData.uid),
                            club: Number(this.state.formData.club_id),
                            kind: 1,
                            level: this.state.formData.level,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (
                    this.state.type === "sendIntegral" ||
                    this.state.type === "recycleIntegral"
                ) {
                    // 发放、回收积分
                    axios
                        .patch("/v1/api/trans_point", {
                            amount:
                                this.state.type === "sendIntegral"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            cid: Number(this.state.formData.uid),
                            club: Number(this.state.formData.club_id),
                            kind: 0,
                            level: this.state.formData.level,
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                } else if (
                    this.state.type === "sendDiamond" ||
                    this.state.type === "recycleDiamond"
                ) {
                    // 发放、回收钻石
                    let url;
                    if (Cookie.get("unionType") === "super_union") {
                        if (this.state.formData.level === 1) {
                            // 超盟转玩家
                            url = "/v1/api/diamond/super_union/user";
                        } else if (this.state.formData.level !== 100) {
                            // 超盟转非玩家
                            url = "/v1/api/diamond/super_union/agent";
                        }
                    } else {
                        if (this.state.formData.level === 1) {
                            // 联盟盟转玩家
                            url = "/v1/api/diamond/union/user";
                        } else if (this.state.formData.level !== 100) {
                            // 联盟转非玩家
                            url = "/v1/api/diamond/union/agent";
                        }
                    }
                    axios
                        .patch(url, {
                            amount:
                                this.state.type === "sendDiamond"
                                    ? Number(values.amount)
                                    : -Number(values.amount),
                            id: Number(this.state.formData.uid),
                            club_id: Number(this.state.formData.club_id),
                        })
                        .then((res) => {
                            if (res.code === 1) {
                                message.success(this.props.language["operationSuccessMessage"]);
                                this.handleClose();
                                this.fetchData();
                            }
                        });
                }
            }
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        let title;
        switch (type) {
            case "sendJetton":
                title = this.props.language["sendChip"];
                break;
            case "recycleJetton":
                title = this.props.language["recycleChip"];
                break;
            case "sendIntegral":
                title = this.props.language["sendIntergral"];
                break;
            case "recycleIntegral":
                title = this.props.language["recycleIntergral"];
                break;
            case "sendDiamond":
                title = this.props.language["sendDiamond"];
                break;
            case "recycleDiamond":
                title = this.props.language["recycleDiamond"];
                break;
        }
        this.setState({
            show: true,
            type,
            title,
            formData: item,
        });
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ show: false });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    user_id: undefined,
                    name: undefined,
                    club_id: undefined,
                    level: undefined,
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["playerIdPlaceholder"]}
                        value={this.state.queryParams.user_id}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("user_id", value)
                        }
                    />
                    <Input
                        allowClear
                        placeholder={this.props.language["playerNamePlaceholder"]}
                        value={this.state.queryParams.name}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("name", e.target.value)
                        }
                    />
                    {Cookie.get("unionType") === "super_union" ? (
                        <Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder={this.props.language["belongClubPlaceholder"]}
                            value={this.state.queryParams.club_id}
                            onChange={(value) =>
                                this.handleSetQueryParamsData("club_id", value)
                            }
                        >
                            {this.state.superUnionClubList.map((item, index) => (
                                <Select.OptGroup label={item.union_name} key={index}>
                                    {item.club_list.map((item2, index2) => (
                                        <Select.Option value={item2.club_id} key={index2}>
                                            {item2.club_name}
                                        </Select.Option>
                                    ))}
                                </Select.OptGroup>
                            ))}
                        </Select>
                    ) : (
                        <Select
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            placeholder={this.props.language["belongClubPlaceholder"]}
                            value={this.state.queryParams.club_id}
                            onChange={(value) =>
                                this.handleSetQueryParamsData("club_id", value)
                            }
                        >
                            {this.state.unionClubList.map((item, index) => (
                                <Select.Option value={item.club_id} key={index}>
                                    {item.club_name}
                                </Select.Option>
                            ))}
                        </Select>
                    )}
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["rolePlaceholder"]}
                        value={this.state.queryParams.level}
                        onChange={(value) => this.handleSetQueryParamsData("level", value)}
                    >
                        {this.state.roleList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["playerId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/player_detail/${item.uid}/${item.club_id}`}>
                                    {item.uid || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerName"]}
                            dataIndex="name"
                        />
                        {Cookie.get("unionType") === "super_union" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["belongUnionId"]}
                                dataIndex=""
                                render={(item) => (
                                    <Link to={`/union_detail/${item.union_id}`}>
                                        {item.union_id || ''}
                                    </Link>
                                )}
                            />
                        )}
                        {Cookie.get("unionType") === "super_union" && (
                            <Table.Column
                                align="center"
                                title={this.props.language["belongUnionName"]}
                                dataIndex="union_name"
                            />
                        )}
                        <Table.Column
                            align="center"
                            title={this.props.language["belongClubId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/club_detail/${item.club_id}`}>{item.club_id || ''}</Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["belongClubName"]}
                            dataIndex="club_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["role"]}
                            dataIndex=""
                            render={(item) => {
                                let role = this.state.roleList.find((item2) => item2.value === item.level)
                                let label = role ? role.label : ""
                                switch (item.level) {
                                    case 100:
                                        return <Tag color="blue">{label}</Tag>
                                    case 10:
                                        return <Tag color="purple">{label}</Tag>
                                    case 9:
                                        return <Tag color="red">{label}</Tag>
                                    case 8:
                                        return <Tag color="magenta">{label}</Tag>
                                    case 7:
                                        return <Tag color="volcano">{label}</Tag>
                                    case 6:
                                        return <Tag color="orange">{label}</Tag>
                                    case 5:
                                        return <Tag color="gold">{label}</Tag>
                                    case 1:
                                        return <Tag>{label}</Tag>
                                }
                            }}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerChip"]}
                            dataIndex="chips"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterPoint"]}
                            dataIndex="point"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["counterDiamond"]}
                            dataIndex="diamond"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerDiamnd"]}
                            dataIndex="wallet_diamond"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalProfit"]}
                            dataIndex="profit"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalServiceFee"]}
                            dataIndex="fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalInsurance"]}
                            dataIndex="ins_profit"
                        />
                        {(Cookie.get("identityType") === "super_union" ||
                            Cookie.get("identityType") === "union") && (
                                <Table.Column
                                    align="center"
                                    title={this.props.language["operation"]}
                                    dataIndex=""
                                    fixed={isMobileDevice() ? false : "right"}
                                    width={120}
                                    render={(item) => (
                                        <>
                                            <Dropdown
                                                trigger={['click']}
                                                overlay={
                                                    <Menu onClick={({ key }) => this.handleShow(key, item)}>
                                                        <Menu.Item key="sendJetton">
                                                            {this.props.language["sendChip"]}
                                                        </Menu.Item>
                                                        <Menu.Item key="recycleJetton">
                                                            {this.props.language["recycleChip"]}
                                                        </Menu.Item>
                                                        {item.level !== 1 && item.level !== 100 && (
                                                            <Menu.Item key="sendIntegral">
                                                                {this.props.language["sendIntergral"]}
                                                            </Menu.Item>
                                                        )}
                                                        {item.level !== 1 && item.level !== 100 && (
                                                            <Menu.Item key="recycleIntegral">
                                                                {this.props.language["recycleIntergral"]}
                                                            </Menu.Item>
                                                        )}
                                                        {item.level !== 100 && (
                                                            <Menu.Item key="sendDiamond">
                                                                {this.props.language["sendDiamond"]}
                                                            </Menu.Item>
                                                        )}
                                                        {item.level !== 1 && item.level !== 100 && (
                                                            <Menu.Item key="recycleDiamond">
                                                                {this.props.language["recycleDiamond"]}
                                                            </Menu.Item>
                                                        )}
                                                    </Menu>
                                                }
                                            >
                                                <Button type="primary" ghost>
                                                    {this.props.language["operation"]}
                                                    <Icon type="down" />
                                                </Button>
                                            </Dropdown>
                                        </>
                                    )}
                                />
                            )}
                    </Table>
                </div>

                {/* 表单弹窗 */}
                <FormModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    onOk={this.handleSubmit}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />
            </div>
        );
    }
}

/**
 * 表单弹窗
 */
const FormModal = Form.create()(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            {/* 发放回收筹码/积分/钻石 */}
                            {(this.props.type == "sendJetton" ||
                                this.props.type == "recycleJetton" ||
                                this.props.type == "sendIntegral" ||
                                this.props.type == "recycleIntegral" ||
                                this.props.type == "sendDiamond" ||
                                this.props.type == "recycleDiamond") && (
                                    <>
                                        <Form.Item label={this.props.language["amount"]}>
                                            {getFieldDecorator("amount", {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: this.props.language["amountVerify"],
                                                    },
                                                ],
                                            })(
                                                <InputNumber
                                                    min={1}
                                                    max={100000000}
                                                    precision={0}
                                                    placeholder={this.props.language["amountPlaceholder"]}
                                                />
                                            )}
                                        </Form.Item>
                                    </>
                                )}
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);
